import React from 'react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'

import { createRoot } from 'react-dom/client';

// NOTE: tailwind-rails gem에 의해 생성된 assets/builds/tailwind.css 와 frontend/styles/tailwind.css 를 동시 포함시키면
//       중복 로딩으로 화면이 깨지는 것 같음. 그냥 한가지만 할수도 없어서(css 가 빠짐. tailwindcss-gem은 typescript는 검색 안함)
//       그냥 browser cdn css를 사용하는 걸로.. ㅠㅠ
//import '../styles/tailwind.css';

// import CssBaseline from '@mui/material/CssBaseline';
// import { ThemeProvider } from '@mui/material/styles';
import App from '../../App';

// import theme from './theme';
const queryClient = new QueryClient();

// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
const rootElement = document.getElementById('root')!;
const root = createRoot(rootElement);

root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
      <ReactQueryDevtools initialIsOpen={false} />
    </QueryClientProvider>
  </React.StrictMode>
);
